import { safeFetch } from "../utils/safeFetch";

const parseOrThrow = async (response) => {
  if (response.ok) {
    if (response.status === 204) return null;
    const text = await response.text();
    return text ? JSON.parse(text) : null;
  }
  if (response.status === 0) throw new Error("Impossibile connettersi al server");
  let payload = null;
  try { payload = await response.json(); } catch (_) { payload = null; }
  throw new Error(payload?.error || `HTTP error! status: ${response.status}`);
};

export const getAllSetups = async (token, tenant) => {
  const response = await safeFetch(`/api/setups`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });
  return parseOrThrow(response);
};

export const createSetup = async (payload, token, tenant) => {
  const response = await safeFetch(`/api/setups`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });
  return parseOrThrow(response);
};

export const updateSetup = async (setupId, payload, token, tenant) => {
  const response = await safeFetch(`/api/setups/${setupId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });
  return parseOrThrow(response);
};

export const deleteSetup = async (setupId, token, tenant) => {
  const response = await safeFetch(`/api/setups/${setupId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });
  return parseOrThrow(response);
};

export const uploadSetupImage = async (file, token, tenant) => {
  const fd = new FormData();
  fd.append("image", file);
  const response = await safeFetch(`/api/setups/upload-image`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: fd,
  });
  return parseOrThrow(response);
};
